import { useState } from 'react';

const NonConformityPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showNonConformityPopup, setShowNonConformityPopup] =
      useState<boolean>(false);

    const nonConformityToggleHandler = () => {
      localStorage.setItem('images', JSON.stringify([]));
      setShowNonConformityPopup(!showNonConformityPopup);
    };

    return (
      <Component
        showNonConformityPopup={showNonConformityPopup}
        nonConformityToggleHandler={nonConformityToggleHandler}
        {...props}
      />
    );
  };

export default NonConformityPopupHOC;
